/**
 * Minimal funnel pricing config — single source of truth until a real
 * Shopify product/variant price is wired in. Replace BASE_PRICE there,
 * not in individual pages, once a real price exists.
 */
window.PfPricing = (() => {
  const BASE_PRICE = 79.99;
  const WOOD_GRASS_PRICE = 15.0;
  const TWIN_DISCOUNT = 0.5;
  const DIFFERENT_PET_DISCOUNT = 0.35;

  function formatPrice(amount) {
    return amount.toFixed(2).replace('.', ',') + ' €';
  }

  function getPrice(state) {
    state = state || {};
    return BASE_PRICE + (state.selectedBase === 'wood_grass' ? WOOD_GRASS_PRICE : 0);
  }

  return { BASE_PRICE, WOOD_GRASS_PRICE, TWIN_DISCOUNT, DIFFERENT_PET_DISCOUNT, formatPrice, getPrice };
})();
